// tslint:disable variable-name
/**
 * 推論結果（APIの戻りのadditional_scoreに対応）
 */
export class InferenceAdditionalResult {
  each_position_score: { // 左肩・天端・右肩のスコア
      left: number;
      top: number;
      right: number;
  };
  each_position_weight: { // 左肩・天端・右肩の重み
      left: number;
      top: number;
      right: number;
  };
  finally_score: number; // 最終評価点
};



// WEBPACK FOOTER //
// ./src/models/InferenceAdditionalResult.ts